import React from "react";
import { YhInput } from "../../../ui/YhInput";

interface inputRangeTypes {
  minLength: number;
  maxLength: number;
}
interface CustomProps {
  label?: string;
  placeHolder?: string;
  value?: string | number;
  onChange?: any;
  type?: string;
  name?: string;
  select?: boolean;
  onKeyPress?: any;
  InputProps?: any;
  error?: any;
  required?: boolean;
  InputLabelProps?: any;
  id?: string;
  sx?: any;
  disabled?: boolean;
  propsToInputElement?: inputRangeTypes;
  onClick?: Function;
  helperText?: string;
  maxLength?: number;
  isLabel?: boolean;
  accept?: any;
  ref?: any;
  maxDate?: any;
  fileUrl?: any;
  children?: React.ReactNode;
}

const CustomInput = (props: CustomProps) => {
  const isLabel = props.isLabel ?? true;
  const { error = null } = props;

  const endAdornment = props.InputProps?.endAdornment;
  const startAdornment = props.InputProps?.startAdornment;

  if (props.select) {
    return (
      <div className="w-full">
        {isLabel && props.label && (
          <label className="yh-label">
            {props.required && <span className="mr-0.5 text-yh-red">*</span>}
            {props.label}
          </label>
        )}
        <select
          id={props.id}
          name={props.name}
          value={props.value as any}
          onChange={props.onChange}
          disabled={props.disabled}
          required={props.required}
          className={`yh-input ${error ? "yh-input-error" : ""}`}
        >
          {props.placeHolder && (
            <option value="" disabled>
              {props.placeHolder}
            </option>
          )}
          {props.children}
        </select>
        {(error || props.helperText) && (
          <p className={`mt-1 text-xs ${error ? "text-yh-red" : "text-yh-light-gray"}`}>
            {error || props.helperText}
          </p>
        )}
      </div>
    );
  }

  return (
    <YhInput
      id={props.id}
      label={isLabel ? props.label : undefined}
      requiredMark={props.required}
      placeholder={props.placeHolder}
      type={props.type}
      name={props.name}
      value={props.value as any}
      onChange={props.onChange}
      onKeyPress={props.onKeyPress}
      required={props.required}
      onClick={props?.onClick as any}
      disabled={props.disabled}
      error={error || undefined}
      helperText={props.helperText}
      autoComplete="off"
      accept={props?.accept}
      maxLength={props.maxLength || props.propsToInputElement?.maxLength}
      minLength={props.propsToInputElement?.minLength}
      max={props.maxDate}
      endAdornment={endAdornment}
      startAdornment={startAdornment}
    />
  );
};

export default CustomInput;
